
import React, { useState } from "react";
import NavBar from "../components/navbar";
// import "../css/aboutme.css"

import SkillFlipCard from "../components/skillcard";




const AboutMe = () => {

    const [activeCardId, setActiveCardId] = useState(null);

  const skills = [
    { id: "js", img: "./skill_tools/javascript.jpg", label: "JavaScript", years: 5 },
    { id: "python", img: "./skill_tools/python.png", label: "Python", years: 6 },
    {id: "Node.js", img: "./skill_tools/node.png", label: "Node.js", years: 2},
    {id: "c++", img: "./skill_tools/c++.png", label: "C++", years: 5},
    {id: "AWS", img: "./skill_tools/aws.png", label: "AWS", years: 2},
    { id: "react", img: "./skill_tools/React.png", label: "React", years: 4 },
    {id: "Git", img: "./skill_tools/git.png", label: "Git", years: 2},
    {id: "Blender", img: "./skill_tools/blender.png", label: "Blender", years: 3},
    {id: "Sklearn", img: "./skill_tools/sklearn.png", label: "sklearn", years: 4},
    {id: "MySQL", img: "./skill_tools/mysql.png", label: "MySQL", years: 4},
    {id: "Docker", img: "./skill_tools/docker.png", label: "Docker", years: 2},
    {id: "Flutter", img: "./skill_tools/Flutter.png", label: "Flutter", years: 3},

  ];

    return (
        <div className = "aboutme-page-container">

           <NavBar />

           <div className = "main-content-container">

                <div className="aboutme-container">
                    <img src="corvallis.jpg" alt ="City of Corvallis"/>

                    <h1 className = "aboutme-passage-title">Personal Background</h1>
                    
                    <p className="aboutme-passage">
                        I was born and raised in Corvallis, Oregon, where I spent 23 years of my life. Traveling out of state, mostly for sporting events, exposed me to new experiences and perspectives. 
                        Over time, this helped shape my decision to pursue a career in computer science and software development. While software development does not typically require travel, the fact that these skills are in demand worldwide reinforced my commitment to this field. 
                        Growing up, my family was deeply rooted in the natural sciences. My father earned a PhD in botany, and both my mother and brother pursued degrees in chemical engineering and biology. Because of this, I was not initially exposed to computer science.<br/><br/>
                        However, my strong interest in mathematics led me toward technology after high school, and I quickly realized it was the right path for me. I enrolled at Oregon State University to study computer science. The journey was not always easy, but over time, I developed a deep passion for programming and software development. 
                        Through coursework and extracurricular projects, I gained valuable technical experience that not only strengthened my programming skills but also gave me the confidence to take on various roles in tech. That experience helped me secure an internship at Videx/Cyberlock, as well as other technical positions at Oregon State University. Along the way, I’ve worked on a wide range of side projects that have helped me refine my skills across multiple programming languages. Some of these include a typing application designed to improve typing speed, websites for family businesses, simple web-based games, and an AI model that predicts MLB game outcomes with the hope of boosting my income into a higher tax bracket. While that last goal hasn’t quite worked out yet, the ability to bring my ideas to life through programming has been incredibly rewarding and has solidified my passion for this field. As a graduate student, I continue to push myself, working on personal projects and expanding my expertise in software engineering. I’m especially focused on deepening my understanding of cloud computing and platforms like AWS, ensuring that I stay on top of emerging technologies and keep growing as a developer.
                    </p>

                </div>
                
                <div className = "skills-panel">
                    
                    <div className = "skills-sub-container">
                        <h1 className = "skill-title">Skills and Tools</h1>

                        <div className = "skills_tools-content">
                            {skills.map((s) => (
                                <SkillFlipCard
                                key={s.id}
                                img={s.img}
                                label={s.label}
                                years={s.years}
                                isFlipped={activeCardId === s.id}
                                onFlip={() =>
                                    setActiveCardId((prev) => (prev === s.id ? null : s.id))
                                }
                                />
                            ))}
                        </div>
                    
                    </div>
                </div>

           </div>

        </div>
    )
}


export default AboutMe;